import { useState, useEffect } from "react";
import Navbar from "../../components/navbar";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import { useMediaQuery, useTheme } from "@mui/material";
import VerificationStep from "../../components/Counselling/VerificationStep";
import AcademicParentInfo from "../../components/Counselling/AcademicParentInfo";
import ContactInformationForm from "../../components/Counselling/ContactInformationForm";
import PersonalInfoForm from "../../components/Counselling/PersonalInfoForm";

export const FirstForm = () => {
  const navigate = useNavigate();
  const [activeStep, changeStep] = useState(0);
  const { user } = useAuth();
  const [idProofFile, setIdProofFile] = useState(null);
  const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    course_id: 1,
  });
  const validate = () => {
    const newErrors = {};
    if (!personalInfo.first_name)
      newErrors.first_name = "First Name is required";
    if (!personalInfo.last_name) newErrors.last_name = "Last Name is required";
    if (!personalInfo.gender) newErrors.gender = "Gender is required";
    if (!personalInfo.birth_date)
      newErrors.birth_date = "Date of Birth is required";
    if (!personalInfo.admission_class)
      newErrors.admission_class = "Admission Class is required";
    return newErrors;
  };

  const [checkingStatus, setCheckingStatus] = useState(true);

  // useEffect(() => {
  //   const checkBuyStatus = async () => {
  //     try {
  //       const response = await apiClient.get("/counselling/buyStatus");
  //       console.log(response);
  //       if (response?.data?.success) {
  //         if (response.data.boughtStatus) {
  //           navigate("/stream-info");
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Failed to check counselling buy status:", error);
  //     } finally {
  //       setCheckingStatus(false);
  //     }
  //   };

  //   checkBuyStatus();
  // }, []);

  const handleNextClick = (e) => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      handleNext(e);
    }
  };

  const handleFileChange = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    const allowedTypes = [".pdf", ".jpg", ".jpeg", ".png"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (file) {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();

      if (!allowedTypes.includes(fileExtension)) {
        alert("Invalid file type. Please upload PDF, JPG, JPEG, or PNG.");
        fileInput.value = "";
        return;
      }

      if (file.size > maxSize) {
        alert("File size exceeds 5MB. Please upload a smaller file.");
        fileInput.value = "";
        return;
      }

      setIdProofFile(file);
      setSelectedFile(file);
    }

    // Reset input value so same file can be re-uploaded later
    fileInput.value = "";
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setIdProofFile(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form before submission
    if (!idProofFile) {
      alert("Please upload an ID proof document.");
      return;
    }

    if (!isDeclarationChecked) {
      alert("Please check the declaration checkbox.");
      return;
    }

    // Create FormData for file upload
    const formData = new FormData();
    formData.append("idProof", idProofFile);
    formData.append("document_type", "ID_PROOF"); // Added document_type as required by backend

    try {
      setUploadStatus("Uploading...");

      //   const response = await apiClient.post(`/users/upload-id-proof`, formData);
      const response = await fetch(
        "https://vhvkknrqif.ap-south-1.awsapprunner.com/api/users/upload-id-proof/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formData,
        },
      );

      const data = await response.json();
      console.log(data);

      if (data.success) {
        setUploadStatus("Document uploaded successfully!");
        // const paymentData = {
        //   firstName: personalInfo.first_name,
        //   lastName: personalInfo.last_name,
        //   email: contactInfo.email_address,
        //   phone: contactInfo.primary_mobile_number,
        //   course_id: 1,
        // };
        // navigate("/courseCheckout", { state: { formData: paymentData } });
        // Optionally handle the returned document URL or other data
        console.log("Data till now :", data.data);
        navigate("/past-info");
      } else {
        setUploadStatus(data.message || "Upload failed");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setUploadStatus("Upload failed. Please try again.");
    }
  };
  // Form states for each step
  const [personalInfo, setPersonalInfo] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    // birth_date: "",
    // admission_class: "",
    // category: "",
    // nationality: "Indian",
    // aadhar_number: "",
  });

  const [contactInfo, setContactInfo] = useState({
    // house_number: "",
    // street_name: "",
    // locality: "",
    city: "",
    // state: "",
    // country: "India",
    // zip_code: "",
    primary_mobile_number: "",
    // secondary_mobile_number: "",
    // email_address: "",
  });

  const [academicInfo, setAcademicInfo] = useState({
    school_name: "",
    school_board: "",
  });

  const [parentInfo, setParentInfo] = useState({
    father_first_name: "",
    father_last_name: "",
    mother_first_name: "",
    mother_last_name: "",
    father_occupation: "",
    mother_occupation: "",
  });

  const steps = [
    "Personal Information",
    "Contact Information",
    "Academic and Parental/Guardian Information",
    "Verification and Declaration",
  ];

  useEffect(() => {
    console.log(user);
    if (!user) {
      navigate("/login", {
        state: { from: "/admission" },
      });
    } else {
      fetchUserProfile();
    }
  }, [user]);

  const fetchUserProfile = async () => {
    try {
      const response = await apiClient.get("/users/profile", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = response.data;
      console.log("data", data);

      if (data.success) {
        console.log("hi");
        if (data.data.personal) setPersonalInfo(data.data.personal);
        if (data.data.contact) setContactInfo(data.data.contact);
        if (data.data.academic) setAcademicInfo(data.data.academic);
        if (data.data.parent) setParentInfo(data.data.parent);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const handleNext = async (e) => {
    e.preventDefault();
    let success = await submitStepData();

    changeStep(activeStep + 1);

    console.log(activeStep);
  };
  const handleBack = () => {
    if (activeStep === 0) {
      return;
    }
    changeStep(activeStep - 1);
  };

  const submitStepData = async () => {
    try {
      switch (activeStep) {
        case 0:
          setPersonalInfo((prev) => ({
            ...prev,
            ...personalInfo,
          }));
          await apiClient.post(`/users/personal-info`, {
            firstName: personalInfo.first_name,
            lastName: personalInfo.last_name,
            gender: personalInfo.gender,
            // dateOfBirth: personalInfo.birth_date,
            // classForAdmission: personalInfo.admission_class,
            // category: personalInfo.category,
            // nationality: personalInfo.nationality,
            // aadharNumber: personalInfo.aadhar_number,
          });
          break;
        case 1:
          setContactInfo((prev) => ({
            ...prev,
            ...contactInfo,
          }));
          await apiClient.post(`/users/contact-info`, {
            // houseNo: contactInfo.house_number,
            // streetName: contactInfo.street_name,
            // area: contactInfo.locality,
            city: contactInfo.city,
            // state: contactInfo.state,
            // country: contactInfo.country,
            // pinCode: contactInfo.zip_code,
            primaryMobile: contactInfo.primary_mobile_number,
            // alternateMobile: contactInfo.secondary_mobile_number,
            // email: contactInfo.email_address,
          });
          break;
        case 2:
          setAcademicInfo((prev) => ({
            ...prev,
            ...academicInfo,
          }));
          setParentInfo((prev) => ({
            ...prev,
            ...parentInfo,
          }));
          await apiClient.post(`/users/academic-info`, {
            schoolName: academicInfo.school_name,
            board: academicInfo.school_board,
            fatherFirstName: parentInfo.father_first_name,
            fatherLastName: parentInfo.father_last_name,
            fatherOccupation: parentInfo.father_occupation,
            motherFirstName: parentInfo.mother_first_name,
            motherLastName: parentInfo.mother_last_name,
            motherOccupation: parentInfo.mother_occupation,
          });
          break;
        default:
          return false;
      }

      return true; // Simulate success
    } catch (error) {
      console.error("Error submitting form:", error);
      return false;
    }
  };

  const CustomStepIcon = ({ active, completed }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const dotSize = isMobile ? 10 : 16;
    const backgroundColor = completed ? "#30B0C7" : "#ccc";

    return (
      <div
        style={{
          width: dotSize,
          height: dotSize,
          background: backgroundColor,
          borderRadius: "50%",
          transition: "background 0.3s",
        }}
      />
    );
  };

  const CustomStep = (props) => {
    const { completed, active } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const dotSize = isMobile ? 10 : 16;
    const backgroundColor = completed ? "#30B0C7" : "#ccc";

    return (
      <CustomStepIcon active={active ? 1 : 0} completed={completed ? 1 : 0}>
        <div
          style={{
            width: dotSize,
            height: dotSize,
            background: backgroundColor,
            borderRadius: dotSize / 2,
          }}
        />
      </CustomStepIcon>
    );
  };

  const renderAdmForm = () => {
    const commonContainerStyle = {
      width: "100%",
      minHeight: "74vh",
      backgroundColor: "#97D7E280",
      borderRadius: "100px 100px 0px 0px",
      padding: "0px 8%",
      marginTop: "70px",
    };

    switch (activeStep) {
      case 0:
        return (
          <PersonalInfoForm
            personalInfo={personalInfo}
            setPersonalInfo={setPersonalInfo}
            errors={errors}
            handleBack={handleBack}
            handleNext={handleNext}
            commonContainerStyle={commonContainerStyle}
            setErrors={setErrors}
          />
        );

      case 1:
        return (
          <ContactInformationForm
            contactInfo={contactInfo}
            setContactInfo={setContactInfo}
            handleBack={handleBack}
            handleNext={handleNext}
            commonContainerStyle={commonContainerStyle}
          />
        );

      case 2:
        return (
          <AcademicParentInfo
            academicInfo={academicInfo}
            setAcademicInfo={setAcademicInfo}
            parentInfo={parentInfo}
            setParentInfo={setParentInfo}
            handleBack={handleBack}
            handleNext={handleNext}
            commonContainerStyle={commonContainerStyle}
          />
        );

      case 3:
        return (
          <VerificationStep
            commonContainerStyle={commonContainerStyle}
            selectedFile={selectedFile}
            handleFileChange={handleFileChange}
            handleRemoveFile={handleRemoveFile}
            isDeclarationChecked={isDeclarationChecked}
            setIsDeclarationChecked={setIsDeclarationChecked}
            handleBack={handleBack}
            handleSubmit={handleSubmit}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <Navbar />
      <div style={{ width: "100%", height: "10vh", marginTop: "5vh" }}>
        <Stepper
          sx={{ flexWrap: "wrap" }}
          activeStep={activeStep}
          alternativeLabel
        >
          {steps.map((label, idx) => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={() => (
                  <CustomStep active={0} completed={activeStep >= idx} />
                )}
              >
                <p
                  style={{
                    fontSize: "10px",
                  }}
                >
                  {" "}
                  {label}{" "}
                </p>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div>{renderAdmForm()}</div>
    </div>
  );
};

export default FirstForm;
